import { ChangeDetectionStrategy, Component, computed, input, InputSignal, output, OutputEmitterRef, Signal } from '@angular/core';
import { MatListItem, MatListItemIcon, MatListItemLine, MatListItemMeta, MatListItemTitle } from '@angular/material/list';
import { ProductTrackingListDirective } from '@libs/shared/tracking';
import { LinkDirective } from '@libs/shared/ui';
import { CatalogSearchSuggestionModel } from '@libs/shop/models';
import { ConfigurableBundleSuggestionCardComponent } from '../../configurable-bundles/configurable-bundle-suggestion-card/configurable-bundle-suggestion-card.component';
import { ProductPriceFormatterComponent } from '../../catalog/product-prices/product-price-formatter';
import { AddToCartSmallComponent } from '../../elements';

@Component({
  selector: 'ui-search-suggestion-card',
  templateUrl: './search-suggestion-card.component.html',
  styleUrls: ['./search-suggestion-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ConfigurableBundleSuggestionCardComponent,
    AddToCartSmallComponent,
    ProductPriceFormatterComponent,
    MatListItem,
    MatListItemIcon,
    MatListItemMeta,
    MatListItemTitle,
    MatListItemLine,
    LinkDirective,
    ProductTrackingListDirective,
  ],
})
export class SearchSuggestionCardComponent {
  public clicked: OutputEmitterRef<void> = output();
  public suggestion: InputSignal<CatalogSearchSuggestionModel> = input.required();
  public position: InputSignal<number> = input.required();

  public productHasPrice: Signal<boolean> = computed(() => !!this.suggestion().prices);
}
